import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateItemInstanceConfigurationRequest, IUpdateItemInstanceConfigurationResponse } from './types';

export const updateItemInstanceConfiguration = async (
  itemId: string,
  extensionInstanceId: string,
  requestBody: IUpdateItemInstanceConfigurationRequest,
): Promise<IUpdateItemInstanceConfigurationResponse> => {
  const response = await fetch(`${API_URL}/items/${itemId}/instance-configuration/${extensionInstanceId}`, {
    method: 'PATCH',
    body: JSON.stringify({ data: { config: requestBody } }),
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error('Something went wrong whilst updating the item instance configuration.');
  }

  return response.json();
};
